// extracted by mini-css-extract-plugin
module.exports = {"quickViewButton":"_3MEjwx","productBase":"uah7kj","shine-lines":"_1uyQzd"};